import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useFmaHistory = (profileUuid, portfolioUuid, shouldRun) => {
  const middleman = useMiddleman();
  return useQuery(['fmaHistory', profileUuid, portfolioUuid], () => {
    return middleman.promiseGet(`/ql/crm/risk-assessment/fma/history/${profileUuid}/${portfolioUuid}`).then(response => response.data);
  }, {
    enabled: shouldRun,
  });
};